import get from 'lodash/get';

export const getContent = (data) => {
    return get(data, ['content', 'content'], '');
};
